export default "__VITE_ASSET__62619ead__"